<div class="blog-containers">
    <div class="title-home-blog">
        <div class="title-blog">
            <h3 *ngIf="type=== news">HÍREK, BLOG</h3>
            <h3 *ngIf="type=== smarty">KISOKOS</h3>
        </div>
    </div>
    <div class="image-container">
        <div class="books">
            <div routerLink="{{ banner.routerLink }}" *ngFor="let banner of blogs" class="book">
                <a><img class="blog-thumb-img" [src]="banner.thumbnailUrl" /></a>
                <div class="blog-title">
                    <h4>{{ banner.title }}</h4>
                </div>
            </div>
        </div>
    </div>
</div>
